<template>
  <v-app id="app">
    <div v-if="!enableDash"></div>
    <div v-else>
      <v-snackbar
        v-model="snackbar.show"
        :timeout="10000"
        multi-line
        left
        top
        :color="snackbar.color"
      >
        {{ snackbar.text }}
        <v-btn flat @click="snackbar.show = false">Close</v-btn>
      </v-snackbar>
      <v-navigation-drawer
        v-model="drawer"
        enable-resize-watcher
        fixed
        app
        width="240"
        class="navColor"
      >
        <h2
          style="text-align: center; color: white; font-size: 30px; font-family: 'Night Machine'; letter-spacing: 2px;"
        >ADMIN</h2>
        <div id="userImg">
          <img
            :src="this['user/user'].avatar || 'https://lh4.googleusercontent.com/-03EW-FpeRBE/AAAAAAAAAAI/AAAAAAAAAAA/ZYNO4RH0oOo/s228-p/photo.jpg'"
            alt="username"
          >
          <p class="userName">{{ this['user/user'].name || "" }}</p>
          <p class="userEmail">{{ this['user/user'].email || "" }}</p>
          <v-divider/>
        </div>
        <v-list id="appList" dense>
          <v-list-tile v-for="(item, i) in routes" :to="item.to" :key="i" router>
            <v-list-tile-action>
              <v-icon v-html="item.icon"/>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-text="item.title"/>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            router
            to="/user-accounts"
            v-if="
            this['user/user'].resources['user']
          "
          >
            <v-list-tile-action>
              <v-icon>fas fa-user-circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>User Accounts</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            router
            to="/company"
            v-if="
            this['user/user'].resources['company']
          "
          >
            <v-list-tile-action>
              <v-icon>fas fa-building</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Company</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-group
            :value="false"
            v-if="
              this['user/user'].resources['evoting-entity'] ||
              this['user/user'].resources['evoting-event']
            "
          >
            <v-list-tile slot="activator">
              <v-list-tile-action>
                <v-icon>fas fa-quote-left</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>E-Voting</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              router
              to="/evoting/entity"
              v-if="this['user/user'].resources['evoting-entity']"
            >
              <v-list-tile-action>
                <v-icon>fas fa-handshake</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Entity</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              router
              to="/evoting/event"
              v-if="this['user/user'].resources['evoting-event']"
            >
              <v-list-tile-action>
                <v-icon>fas fa-bell</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Event</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>

          <v-list-group :value="false">
            <v-list-tile slot="activator">
              <v-list-tile-action>
                <v-icon>fas fa-shield-alt</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Authentication</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile router to="/authentication/create">
              <v-list-tile-action>
                <v-icon>fas fa-plus</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Create</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              router
              to="/authentication/resource"
              v-if="this['user/user'].resources['resource']"
            >
              <v-list-tile-action>
                <v-icon>fas fa-plug</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Resources</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              router
              to="/authentication/action"
              v-if="this['user/user'].resources['action']"
            >
              <v-list-tile-action>
                <v-icon>fas fa-location-arrow</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Actions</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              router
              to="/authentication/role"
              v-if="this['user/user'].resources['role']"
            >
              <v-list-tile-action>
                <v-icon>fas fa-scroll</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Roles</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>

          <v-list-tile router to="/settings">
            <v-list-tile-action>
              <v-icon>fas fa-cogs</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>User Settings</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar id="nav-color" app dark flat dense>
        <v-btn icon dark color="primary" @click.stop="drawer = !drawer">
          <v-icon>{{ drawer ? 'chevron_left' : 'chevron_right' }}</v-icon>
        </v-btn>
        <v-spacer/>
        <h2
          style="font-family: 'Night Machine'; color: #272727; font-weight: 100; font-size: 40px;"
        >Adler</h2>
        <v-spacer/>
        <v-menu offset-y min-width="200" nudge-top="-6">
          <v-btn slot="activator" icon color="primary">
            <v-icon>person</v-icon>
          </v-btn>
          <v-list>
            <v-subheader>About User</v-subheader>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <img
                  :src="this['user/user'].avatar || 'https://lh4.googleusercontent.com/-03EW-FpeRBE/AAAAAAAAAAI/AAAAAAAAAAA/ZYNO4RH0oOo/s228-p/photo.jpg'"
                  alt="username"
                >
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{this['user/user'].name}}</v-list-tile-title>
                <v-list-tile-sub-title
                  style="text-transform: capitalize;"
                >{{this['user/user'].company.name}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-btn flat small to="/settings">Settings</v-btn>
              </v-list-tile-action>
              <v-list-tile-action>
                <v-btn flat small>Logout</v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-content>
        <v-fade-transition mode="out-in">
          <router-view/>
        </v-fade-transition>
      </v-content>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    drawer: true,
    routes: [
      { icon: "fas fa-tachometer-alt", title: "Dashboard", to: "/" },
      { icon: "fas fa-plus", title: "Create", to: "/create" }
    ],
    enableDash: false
  }),
  computed: {
    ...mapGetters(["user/user", "snackbar"])
  },
  methods: {},
  async mounted() {
    this.$store.watch(val => {
      const { user } = val.user;
      if (
        user &&
        user.id &&
        user.actions.length > 0 &&
        user.actions.indexOf("read/AdminDashboard") > -1
      ) {
        this.enableDash = true;
      }
    });
    await this.$store.dispatch("user/getAccount");
  }
};
</script>

<style lang="stylus">
@import './assets/stylus/App.styl';
</style>
